<template>
  <div class="fts-control-modal">
    <!-- Information Modal -->
    <modal
      class="fts-v-modal"
      :height="'auto'"
      :width="'800px'"
      :scrollable="true"
      :adaptive="true"
      @before-open="beforeOpen"
      @before-close="beforeClose"
      :name="'controlModal' + modalNameId"
    >
      <div class="fts-v-modal-header">
        <div
          class="fts-v-modal-header-title"
        >{{formData.displayName? formData.displayName : 'Enter Name'}}</div>
      </div>

      <div class="fts-v-modal-content">
        <div class="fts-v-modal-content-body">
          <fts-form :fields="form" :formData="formData" :form="form"></fts-form>

          <div v-if="formData.input == 'button'">
            <fts-script-editor
              editor-id="buttonFrontEndScript"
              v-model="formData.frontendScript"
              label="Frontend Script"
              lang="javascript" />
          </div>

          <div v-if="formData.input == 'button'">
            <fts-form :formData="formData" :form="{ 'rows': [{ 'items': [{ 'fieldName': 'eventName', 'displayName': 'Event Name' }]}] }"></fts-form>
          </div>

          <template v-if="beta">
            <!-- filter form data-->
            <div>
              <label class="fts-form-label label-top">Filter Form Data <fts-release-badge class="control-modal-label-rb" /></label>
              <div class="fts-form-group">
                <input
                  class="fts-form-control"
                  type="text"
                  autocomplete="off"
                  v-model="formData.autoCompleteFormDataFields" />
              </div>
            </div>
            <!-- script only -->
            <div v-if="formData.type == 7 || formData.type == 20">
              <fts-form :formData="formData" :form="{ 'rows': [{ 'items': [{ 'fieldName': 'scriptOnly', 'displayName': 'Script Only', type: 1 }]}] }"></fts-form>
            </div>
            <!-- filter -->
            <div v-if="formData.type == 7 || formData.type == 20">
              <label class="fts-form-label label-top">Filter <fts-release-badge class="control-modal-label-rb" /></label>
              <div class="fts-form-group">
                <fts-query-designer    
                  :filter="formData.filter"
                  :states="moduleStates"
                  :informationSource="selection" />
              </div>
            </div>
            <!-- query script -->
            <div v-if="formData.type == 7 || formData.type == 20">
              <label class="fts-form-label label-top">Query Script <fts-release-badge class="control-modal-label-rb" /></label>
              <div class="fts-form-group">
                <fts-script-editor
                  editor-id="queryScript"
                  v-model="formData.queryScript"
                  lang="python" />
              </div>
            </div>
            <!-- sort -->
            <div> 
              <label class="fts-form-label label-top">Sort <fts-release-badge class="control-modal-label-rb" /></label>
              <div class="fts-form-group" style="display: flex;align-items: center;">
                <fts-sort :fields="sortSelection" v-model="formData.sort" />
              </div>
            </div>     
          </template>

          <div v-if="formData.type == 15">
            <div>List</div>
            <fts-form :formData="formData" :form="{ 'rows': [{ 'items': [{ 'fieldName': 'displayField', 'displayName': 'Display Field' }]}] }"></fts-form>
          </div>

          <!-- Temp disable due to fields and columns issues formData.type === 14 || formData.type === 15 -->
          <div v-if="false" class="class-info">
            <div class="content-body-main-label">Fields</div>
            <!-- Classification -->
            <div class="classification-container">
              <div class="classification-information" v-if="formData.fields">
                <draggable
                  v-model="formData.fields"
                  v-bind="dragOptions"
                  handle=".class-info-handle"
                  class="class-info-container"
                >
                  <div
                    v-for="(classInfo, index) in formData.columns"
                    :key="classInfo.information.id"
                    :class="{ 'over': show == index }"
                    @mouseover="show = index"
                    @mouseleave="show = -1"
                    class="class-info-wrapper"
                  >
                    <div class="class-info-inner-wrapper">
                      <div class="class-info-item">
                        <div class="class-info-item-wrapper">
                          <font-awesome-icon
                            :icon="['fas', 'grip-vertical']"
                            fixed-width
                            class="class-info-handle"
                            @click.stop
                          />
                          <i class="class-info-icon" :class="getIcon(classInfo.information.type)"></i>
                          <div
                            class="class-info-display-name"
                            @click="showInformation(classInfo.information)"
                          >{{classInfo.information.displayName}}</div>
                          <span class="fts-badge-legacy" v-if="classInfo.required">Required</span>
                          <span class="fts-badge-legacy" v-if="classInfo.readOnly">Read Only</span>
                          <span class="fts-badge-legacy" v-if="classInfo.due">Due</span>
                          <span class="fts-badge-legacy" v-if="classInfo.assignee">Assignee</span>
                          <span
                            class="fts-badge-legacy"
                            v-if="classInfo.addRemoveItems"
                          >Add/Remove Items</span>
                        </div>
                      </div>
                    </div>

                    <div class="class-info-additional-action" v-if="show === index">
                      <span
                        class="fts-badge-legacy"
                        :class="{'active': classInfo.required}"
                        @click.stop="classInfo.required = !classInfo.required"
                      >Required</span>
                      <span
                        class="fts-badge-legacy"
                        :class="{'active': classInfo.readOnly}"
                        @click.stop="classInfo.readOnly = !classInfo.readOnly"
                      >Read only</span>

                      <!-- Visibility Script -->
                      <font-awesome-icon :icon="['far', 'eye']" fixed-width class="edit-action" />
                      <font-awesome-icon
                        :icon="['fas', 'cog']"
                        fixed-width
                        class="edit-action"
                        @click="showInformation(classInfo.information)"
                      />
                      <font-awesome-icon
                        :icon="['fas', 'times']"
                        fixed-width
                        class="remove-action"
                        @click.stop="modalConfirmation('removeInformation', classInfo)"
                      />
                    </div>
                  </div>
                </draggable>
              </div>
            </div>

            <div class="class-info-action">
              <input
                class="fet-form-control"
                v-model="newInformation.displayName"
                :placeholder="'create field'"
                taggable
                label="displayName"
                :options="information"
              />
              <v-select
                v-model="newInformation.typeModel"
                :key-property="'id'"
                @keyUpdate="newInformation.type = $event"
                label="type"
                :text="newInformation && newInformation.typeModel? newInformation.typeModel.type : ''"
                :options="informationTypes"
              ></v-select>
              <button
                type="button"
                class="fts-btn fts-btn-outline fts-btn-primary fts-btn-icon-mr"
                @click="addInformation()"
              >
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />Add
              </button>
            </div>
          </div>
          <!-- advanced -->
          <fts-collapsible-element v-model="advanced">
            <fts-btn
              slot="toggle"
              slot-scope="{ isVisible, toggle }"
              text
              text-transform-init
              :class="{ open: isVisible }"
              class="design-modal-advanced-toggle"
              @click="toggle()"
            >
              Advanced settings
              <font-awesome-icon
                :icon="['fas', 'caret-right']"
                class="design-modal-advanced-toggle-icon"
              />
            </fts-btn>
            <div slot="content" class="fts-row gutters">
              <!-- field name -->
              <fts-form-element
                :form-data="formData"
                :item="{
                  fieldName: 'fieldName',
                  type: 0,
                  readOnly: !this.formData.custom
                }"
                class="fts-col"
              />
            </div>
          </fts-collapsible-element>
        </div>

        <div class="fts-v-modal-content-footer">
          <div></div>
          <fts-btn outline color="primary" @click="close">
            <font-awesome-icon :icon="['fas', 'check']" /> Ok
          </fts-btn>
        </div>

        <font-awesome-icon
          :icon="['fas', 'times']"
          fixed-width
          class="close-action"
          @click="close"
        />
      </div>
    </modal>

    <FTSNestedInformationModal @delete="deleteNested" @confirm="confirmNested"></FTSNestedInformationModal>
  </div>
</template>

<script>
import FTSForm from "../elements/FTSForm";
import commons from "../commons/commons";
import draggable from "vuedraggable";
import vSelect from "../vue-select/index";
import FTSNestedInformationModal from "./FTSNestedInformationModal";
import Vue from "vue";

import queryLogic from "../commons/queryLogic";
import FTSScriptEditor from "../design/FTSScriptEditor";
import FTSQueryDesigner from "./FTSQueryDesigner";
import FTSContenteditable from "../elements/FTSContenteditable";
import FTSSort from "../elements/FTSSort";
import FTSReleaseBadge from "../elements/FTSReleaseBadge";
import FTSBtn from "../elements/FTSBtn";
import FTSCollapsibleElement from "../elements/FTSCollapsibleElement";
import FTSFormElement from "../elements/FTSFormElement";

export default {
  props: ["modalNameId"],
  data() {
    let vm = this;
    return {
      formData: {},
      lookupSelection: [],
      dragOptions: commons.dragOptions,
      show: -1,
      newInformation: {},
      advanced: false,
      informationTypes: commons.informationTypes,
      form: {
        rows: [
          {
            items: [
              {
                displayName: "Name",
                fieldName: "displayName",
                input: "text",
                hiddenFunc: (formData) => !formData.custom,
              },
              {
                displayName: "Label (Optional)",
                fieldName: "label",
                input: "text",
              },
            ],
          },
          // {
          //   items: [
          //     {
          //       displayName: "Field Name",
          //       fieldName: "fieldName",
          //       input: "text",
          //     },
          //   ],
          // },
          {
            items: [
              {
                displayName: "Description",
                fieldName: "description",
                input: "textArea",
              },
            ],
          },
          {
            items: [
              {
                displayName: "Type",
                fieldName: "typeText",
                input: "dropDown",
                key: "type",
                displayProperty: "type",
                // FETIAS Issue SS00217, temp disabled
                optionList: commons.informationTypes.filter(
                  x => x.id !== 14 && x.id !== 15 && x.id !== 30
                ),
                // hiddenFunc: formData => this.hidden("type", formData)
              },
              {
                displayName: "Format",
                fieldName: "predefinedFormat",
                type: 0,
                readOnly: true,
                hiddenFunc: (formData) => this.hidden("formatDisplay", formData),
              },
              {
                displayName: 'Enable Custom Format',
                fieldName: 'enableCustomDateFormat',
                type: 1,
                hiddenFunc: (formData) => this.hidden("formatDisplay", formData),
              },
              {
                displayName: "Custom Format",
                fieldName: "customDateFormat",
                input: "dropDown",
                optionList: commons.dateFormats,
                hiddenFunc: (formData) => this.hidden("customDateFormat", formData),
              },
              {
                displayName: "Format",
                fieldName: "predefinedFormatId",
                input: "dropDown",
                optionList: commons.dateFormats,
                hiddenFunc: (formData) => this.hidden("format", formData),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Prefix (beta)",
                fieldName: "prefix",
                input: "text",
                hiddenFunc: (formData) => this.hidden("prefix", formData, true),
              },
              {
                input: "empty",
              },
            ],
          },
          {
            items: [
              {
                displayName: "With time (beta)",
                fieldName: "withTime",
                input: "boolean",
                hiddenFunc: (formData) => this.hidden("withTime", formData, true),
              },
              {
                input: "empty",
              },
            ],
          },
          {
            items: [
              {
                displayName: "Extra (Module)",
                fieldName: "connection",
                key: "connectionId",
                input: "dropDown",
                displayProperty: 'name',
                optionList: this.lookupSelection,
                hiddenFunc: (formData) => this.hidden("lookup", formData),
              },
              {
                displayName: "Information (Module's Information)",
                fieldName: "searchField",
                input: "dropDown",
                key: "searchFieldId",
                displayProperty: "displayName",
                // optionList: this.formData.connectionModel.information,
                hiddenFunc: (formData) => this.hidden("searchField", formData),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Connection ID",
                fieldName: "connectionId",
                input: "integer",
                readOnly: true,
                hiddenFunc: (formData) => this.hidden("connectionId", formData),
              },
              {
                displayName: "Preload",
                fieldName: "test",
                input: "boolean",
                hiddenFunc: (formData) => this.hidden("lookup", formData),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Allow multiple (beta)",
                fieldName: "allowMultiple",
                input: "boolean",
                hiddenFunc: (formData) =>
                  this.hidden("allowMultiple", formData, true),
              },
              {
                input: "empty",
              },
            ],
          },
          {
            items: [
              {
                displayName: "Options",
                fieldName: "optionList",
                input: "table",
                type: 14,
                readOnly: true,
                fields: [
                  {
                    displayName: "Name",
                    fieldName: "name",
                    type: 0,
                  },
                  {
                    fieldName: "color",
                    displayName: "Color",
                    type: 0,
                  },
                ],
                addRemoveItems: true,
                hiddenFunc: (formData) => this.hidden("optionsDisplay", formData), 
              },
              {
                displayName: "Options",
                fieldName: "optionList",
                input: "table",
                type: 14,
                fields: [
                  {
                    displayName: "Name",
                    fieldName: "name",
                    type: "text",
                  },
                  {
                    fieldName: "color",
                    displayName: "Color",
                    type: "text",
                  },
                ],
                addRemoveItems: true,
                hiddenFunc: (formData) => this.hidden("options", formData),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Column Width (beta)",
                fieldName: "columnWidth",
                input: "integer",
                hiddenFunc: (formData) => this.hidden('columnWidth', formData, true),
              },
            ],
          },
          {
            items: [
              {
                displayName: "Decimal Places",
                fieldName: "decimalPlaces",
                input: "integer",
                hiddenFunc: (formData) => this.hidden('decimalPlaces', formData),
              },
            ],
          },
        ],
      },
    };
  },
  components: {
    "fts-form": FTSForm,
    draggable,
    "fts-sort": FTSSort,
    "v-select": vSelect,
    FTSNestedInformationModal,
    "fts-script-editor": FTSScriptEditor,
    "fts-query-designer": FTSQueryDesigner,
    "fts-contenteditable": FTSContenteditable,
    "fts-release-badge": FTSReleaseBadge,
    "fts-btn": FTSBtn,
    "fts-collapsible-element": FTSCollapsibleElement,
    "fts-form-element": FTSFormElement,
  },
  watch: {
    "formData.type": function () {
      if (this.formData.type == 27 && !this.formData.optionList) {
        this.formData.optionList = [];
      }
    },
    formData: function () {
      console.log("change form data");
    },
  },
  methods: {
    beforeOpen(event) {
      let payload = event.params;
      if (payload.formData) {
        this.formData = payload.formData;
        /* set type */
        if (!this.formData.type) 
          this.$set(this.formData, "type", 0);
        /* set field name */
        if (!this.formData.fieldName)
          this.$set(this.formData, "fieldName", commons.generateFieldName())
        /* set predefined format (date) */
        if ((this.formData.type == 5 || this.formData.type == 6) && this.formData.predefinedFormatId) {
          const predefinedFormat = commons.dateFormats.find(x => x.id === this.formData.predefinedFormatId);
          if (predefinedFormat)
            this.formData.predefinedFormat = predefinedFormat.name;
        }
      }
    },
    beforeClose() {
      if (this.formData.custom && (this.formData.type == 7 || this.formData.type == 20) && this.formData.searchField && !this.formData.connectionField) {
        this.formData.connectionField = this.formData.searchField
        this.formData.connectionFieldId = this.formData.searchFieldId
        console.info(`${this.formData.displayName} migrated Connection Field`, {res: this.formData})
      }
    },
    hidden(type, formData, isBeta) {
      if (isBeta && !this.beta)
        return true

      if (
        type == "format" &&
        (formData.type == 5 || formData.type == 6) &&
        formData.custom
      ) {
        return false
      } else if (
        type == "customDateFormat" && 
        (formData.type == 5 || formData.type == 6) &&
        (!formData.custom && formData.enableCustomDateFormat)
      ) {
        return false;
      } else if (
        type == "formatDisplay" && 
        (formData.type == 5 || formData.type == 6) &&
        !formData.custom
      ) {
        return false;
      } else if (type == "withTime" && (formData.type == 5 || formData.type == 6)) {
        return false;
      } else if (type == "prefix" && formData.type == 4) {
        return false;
      } else if (
        type == "allowMultiple" &&
        [10, 12, 7, 20].some((y) => formData.type == y)
      ) {
        return false;
      } else if (
        type == "lookup" && 
        [7, 8, 20].some((y) => formData.type == y) &&
        formData.custom
      ) {
        return false;
        // return !formData.custom;
        // if ([7, 8, 20].some((y) => formData.type == y)) return false;
      } else if (
        type == "searchField" &&
        [7, 8, 20].some((y) => formData.type == y) &&
        formData.custom
      ) {
        return false;
        // return !formData.custom;
      } else if (
        type == "connectionId" &&
        [7, 8, 20].some((y) => formData.type == y)
      ) {
        return false;
      } else if (type == "options" && formData.type == 27 && formData.custom) {
        return false;
      } else if (type == "optionsDisplay" && formData.type == 27 && !formData.custom) {
        return false;
      } else if (type == "type" && formData.custom) {
        return false;
      } else if (type == "columnWidth") {
        const tables = this.information.filter(x => x.type == 14) 
        return !tables.some(x => x.fields && Array.isArray(x.fields) && x.fields.some(y => y.id == formData.id))
      } else if (type == "decimalPlaces" && formData.type === 3) {
        return false
      }

      return true;
    },
    addInformation() {
      if (this.formData.fields == null) {
        this.formData.fields = [];
      }

      let informationField = _.cloneDeep(this.newInformation);
      informationField.id = commons.newUUID();
      delete informationField.typeModel;

      this.formData.fields.push({ information: informationField });
      // if (!this.newInformation.id) {
      //   this.$store.dispatch("confirmInformation", {
      //     information: this.newInformation
      //   });
      // }

      // this.activity.classification.push({
      //   id: commons.newUUID(),
      //   information: this.newInformation
      // });

      this.newInformation = {};
    },
    close() {
      this.advanced = false;
      this.$emit("ok", this.formData);
      this.$modal.hide("controlModal" + this.modalNameId);
    },
    deleteNested(nested) {
      this.formData.fields = this.formData.fields.filter(
        (x) => x.information.id != nested.id
      );
    },
    confirmNested(nested) {
      let field = this.formData.fields.find(
        (x) => x.information.id == nested.id
      );
      Object.assign(field.information, nested);
    },
  },
  watch: {
    "formData.connectionModel": function (val) {
      if (val) {
        let vm = this;
        vm.form.rows[5].items[1].optionList = val.information;
      }
    },
    "formData.connectionId": function (val) {
      let vm = this;
      vm.form.rows[5].items[1].optionList = vm.moduleInformation;
    },
    "formData.custom": function (val) {
      if (val) {
        let vm = this;
        this.$store.dispatch("loadVectorSelection").then(function (res) {
          vm.form.rows[5].items[0].optionList = res.data;
          vm.lookupSelection = res.data;
        });
      }
    },
    "formData.type": function (val) {
      if (val == 7 || val == 20) {
        if (!this.formData.filter) {
          Vue.set(this.formData, "filter", { items: [] });
        }

        let vm = this;
        this.$store.dispatch("loadVectorSelection").then(function (res) {
          vm.form.rows[5].items[0].optionList = res.data;
          vm.lookupSelection = res.data;
        });
      }
    },
  },
  computed: {
    beta() {
      return this.$store.state.beta;
    },
    information() {
      return this.$store.state.canvas.information;
    },
    states() {
      return this.$store.state.canvas.states;
    },
    selection() {
      let differenceList = [];
      if (this.formData.type != 20) differenceList.push("username");
      if (this.moduleStates && !this.moduleStates.length) differenceList.push("state");
      return _.differenceWith(
        queryLogic.querySelectionPrefix,
        differenceList,
        ({ id }, key) => id === key
      ).concat(this.moduleInformation).concat(queryLogic.querySelectionSuffix);    
      // return queryLogic.querySelectionPrefix
      //   .concat(this.moduleInformation)
      //   .concat(queryLogic.querySelectionSuffix);
    },
    sortSelection() {
      let differenceList = ["collaboration", "assignTo", "due", "createdBy", "lastChangeBy"];
      if (this.formData.type != 20) differenceList.push("username");
      if (this.moduleStates && !this.moduleStates.length) differenceList.push("state");
      return _.differenceWith(
        queryLogic.querySelectionPrefix,
        differenceList,
        ({ id }, key) => id === key
      ).concat(this.moduleInformation);
    },
    moduleInformation() {
      if (Array.isArray(this.lookupSelection) && this.formData.connectionId) {
        const findModule = this.lookupSelection.find(x => x.id == this.formData.connectionId);
        if (findModule && findModule.information)
          return findModule.information;
      }
      return [];
    },
    moduleStates() {
      if (Array.isArray(this.lookupSelection) && this.formData.connectionId) {
        const findModule = this.lookupSelection.find(x => x.id == this.formData.connectionId);
        if (findModule && findModule.states)
          return findModule.states;
      }
      return [];
    },
  },
  created() {
    if (this.formData.custom) {
      let vm = this;
      this.$store.dispatch("loadVectorSelection").then(function (res) {
        vm.form.rows[5].items[0].optionList = res.data;
        vm.lookupSelection = res.data;
        vm.form.rows[5].items[1].optionList = vm.moduleInformation;
      });
    }

    if (this.formData.type == 7 || this.formData.type == 20) {
      this.formData.filter = { items: [] };
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/vars.scss";

.fts-control-modal {
  .class-info {
    margin-bottom: 2rem;
    .class-info-label {
      font-size: 0.875rem;
      color: $grayLightColor;
      letter-spacing: 0.09em;
    }
    .class-info-wrapper {
      display: flex;
      flex-wrap: wrap;
      padding: 6px;
      &:hover {
        background: #eeeeee;
      }
      .class-info-inner-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .class-info-item {
          .class-info-display-name {
            display: flex;
            align-items: center;
            color: $darkColor;
            .class-info-icon {
              display: inline-flex;
              margin-right: 6px;
              color: $secondaryColor;
            }
          }
        }
        .class-info-setting {
          > svg {
            color: $grayLightColor;
            &.remove-action:hover {
              color: $dangerColor;
            }
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    .class-info-action {
      display: flex;
      margin-top: 0.75rem;
      > input {
        margin-right: 6px;
        font-size: 0.875rem;
        max-width: 60%;
      }
      > .v-select {
        margin-right: 6px;
        flex: 1;
      }
    }
  }

  @media (min-width: 768px) {
    .fts-form-container .fts-form-item {
      .fts-form-element-container.compact-form-design .fts-form-label {
        min-width: 100px;
        width: 100px;
      }
    }
  }

  /* clone from FTSDesignModal */
  /* advanced toggle */
  .design-modal-advanced-toggle {
    margin-left: -0.75rem; 
    margin-bottom: 1rem;
    &.open {
      .design-modal-advanced-toggle-icon {
        transform: rotate(90deg);
      }
    }
    .design-modal-advanced-toggle-icon {
      margin-left: .75rem;
      margin-right: 0;
      transition: transform .3s;
    }
  }
}
</style>